import { Button } from "@circleco/compass/components/Button";

import { t } from "@/i18n-js/instance";

import { useButtonActions } from "./hooks/useButtonActions";

export const UpgradeDeclineButton = ({
  stepId,
  disabled = false,
}: {
  stepId: number;
  disabled?: boolean;
}) => {
  const { refuseMutation } = useButtonActions({ stepId });

  return (
    <Button
      type="button"
      variant="ghost"
      fullWidth
      disabled={disabled || refuseMutation.isPending}
      loading={refuseMutation.isPending}
      onClick={() => refuseMutation.mutate()}
    >
      {t(["paywall_checkout.offer_page", "no_thank_you"])}
    </Button>
  );
};
